module.exports = __webpack_public_path__ + "img/registration-progress.5c545f56.svg";